import { GetPlatformCatalogsParams } from "@bvhi/backend-api/apis";
import { Card, Stack } from "@bvhi/ui-base";
import { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { BVHINavigationCreateEntityButton } from "../../../../../components/bvhi-navigation-create-entity-button";
import { NavigationBar } from "../../../../../components/navigation-bar";
import { useBVHIDataGridFilter } from "../../../../../hooks/use-bvhi-datagrid-Filter";
import { Route } from "../../../../../routes/_main/app/catalogs.index";
import { CatalogsErrorAlerts } from "./components/catalogs-error-alerts";
import { CatalogsFilterCard } from "./components/catalogs-filter-card";
import { CatalogsDataGrid } from "./components/datagrid/catalogs-data-grid";
import { defaultCatalogsFilter } from "./components/default-catalogs-filter";
import { useCatalogsSortParams } from "./hooks/use-catalogs-sort-params";

export const CatalogsListView = () => {
  const searchParams = Route.useSearch();
  const { t } = useTranslation(["catalogs"]);
  const { getSortConfig } = useCatalogsSortParams();
  const { resetFilter, handleFilterChange, handleDataGridChange, requestParams } = useBVHIDataGridFilter<GetPlatformCatalogsParams>(
    defaultCatalogsFilter,
    Route.fullPath,
    getSortConfig,
    searchParams
  );

  return (
    <>
      <NavigationBar
        showBreadcrumbs={true}
        actions={[
          <BVHINavigationCreateEntityButton
            key={0}
            entity={t("catalogs:catalogs.catalog")}
            navigateTarget={{ to: "/app/catalogs/create" }}
          />,
        ]}
      />

      <Stack pt={2} spacing={2}>
        <CatalogsErrorAlerts />

        <CatalogsFilterCard filter={requestParams} onChange={handleFilterChange} onReset={resetFilter} />

        <Suspense fallback={<Card sx={{ height: 300, minHeight: 300 }} />}>
          <CatalogsDataGrid updateCallback={handleDataGridChange} />
        </Suspense>
      </Stack>
    </>
  );
};
